
import { defineComponent } from "vue";
import DCatalogueCatalogue from "@/components/catalogues/DCatalogueCatalogue/DCatalogueCatalogue.vue";

export default defineComponent({
  components: {
    DCatalogueCatalogue,
  },
  props: {},
  methods: {},
  computed: {},
  data() {
    return {};
  },
});
